@if (!meetingDataFoundMessage) {
  <div #allMeetings class="grid">
    @for (meeting of meetings; track meeting; let i = $index) {
      <div class="col-12 md:col-6 lg:col-6 meeting-cards-mergin">
        <div
          [class]="
            meeting.meetingType === 'Meeting'
              ? 'meetings-card-bar'
              : 'appeal-card-bar'
          "
        ></div>
        <div class="meetingCard">
          <div class="meetingsCardMargin">
            <b>{{ meeting.meetingTypeInfo }}</b>
            <b class="float-right meeting-status-font">
              {{ meeting.meetingStatus }}</b
            >
          </div>
          @if (meeting.meetingDateMsg) {
            <div class="meetingsCardMargin">
              <b>Meeting Date</b> {{ meeting.meetingDateMsg }}
            </div>
          }
          @if (meeting.decisionResult) {
            <div class="meetingsCardMargin">
              <b>Outcome</b> {{ meeting.decisionResult }}
            </div>
          }
          <div class="meetingsCardMargin">
            @if (meeting.appealMeetingRequestMsg) {
              <br />
            }
            {{ meeting.appealMeetingRequestMsg }}
          </div>
          <div class="meetingsCardMargin">
            @if (meeting.SENExpertRevReqMsg) {
              <br />
            }
            {{ meeting.SENExpertRevReqMsg }}
          </div>
          <br />
          @if (meeting.meetingAttendees.length > 0) {
            <div class="meetingsCardMargin">
              Attended By:
              <ul class="meetingsCardMargin">
                @for (attendee of meeting.meetingAttendees; track attendee) {
                  <li>
                    {{ attendee }}
                  </li>
                }
              </ul>
            </div>
          }
          @if (!pupilData.isOffRoll || isOffRollEditingEnabled) {
            <div
              class="split-button-container-secondary confirmation-button-container"
            >
              <p-splitButton
                label="Edit"
                value="Edit"
                (onClick)="
                  showEditMeetingDialog(
                    meeting.meetingAppealId,
                    meeting.meetingType,
                    i
                  )
                "
                class="button-custom float-right meeting-status-font"
                [model]="splitActionButtons[i]"
                attr.ri="{{ i }}"
                (onDropdownClick)="findMeetingIndex(i)"
                #editMeetingSplitButton
              ></p-splitButton>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
<div class="col-12">
  @if (meetingDataFoundMessage) {
    <div>{{ noMeetingsCreatedMessage }}</div>
  }
</div>
@if (!pupilData.isOffRoll || isOffRollEditingEnabled) {
  <div class="grid">
    <div class="col">
      <button
        pButton
        type="button"
        class="float-right"
        (click)="showAddMeetingDialog()"
        label="Add a meeting"
        #addMeetingButton
      ></button>
    </div>
  </div>
}
<div style="clear: both"></div>

<p-dialog
  class="popupPreference"
  id="addEditMeeting"
  #addEditMeetingPopUp
  [(visible)]="display"
  [modal]="true"
  styleClass="mydialog"
  [closable]="false"
  [draggable]="false"
  (onShow)="focusFirstInputControl()"
>
  <ng-template pTemplate="header">
    <div class="popupHeader">
      <span class="p-dialog-title ng-tns-c75-17 ng-star-inserted">
        {{ popupHeaderText }}</span
      >
    </div>
    <div class="popupHeaderCloseButton">
      <button
        pButton
        class="p-dialog-header-icon"
        type="button"
        (click)="closePopup()"
        icon="pi pi-times"
      ></button>
    </div>
  </ng-template>

  <div class="required-field-disclaimer padding-bottom-a-rem">
    Mandatory fields are marked with a red asterisk <span class="red">*</span>
  </div>
  <form [formGroup]="meetingFields">
    <div>
      @if (!isEdit) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-zero">
            <label
              class="margin-bottom-half-rem"
              for="meetingType"
              id="lblMeetingType"
              >Meeting type <span class="error-label">*</span></label
            >
            <div class="margin-top-half-rem">
              <p-select
                formControlName="meetingType"
                [options]="meetingTypes"
                optionLabel="description"
                optionValue="value"
                id="meetingType"
                (onChange)="setIsMeetingFlag($event.value)"
                #dropdownMeetingType
                ariaLabelledBy="lblMeetingType"
              ></p-select>
            </div>
          </div>
        </div>
      }
      @if (isMeeting) {
        <div class="col-12 padding-zero">
          <div class="col-4 padding-top-a-rem">
            <label for="meetingDateTime"
              >Meeting date and time <span class="error-label">*</span></label
            >
            <div id="divMeetingDateAndTime" class="margin-top-half-rem">
              <p-datepicker
                formControlName="meetingDateTime"
                dateFormat="dd/mm/yy"
                placeholder="DD/MM/YYYY HH:MM"
                [minDate]="minDateMeeting"
                [maxDate]="maxDateMeeting"
                keepInvalid="false"
                [monthNavigator]="true"
                (onInput)="onManualMeetingDateTimeEntered($event)"
                showTime="true"
                inputId="meetingDateTime"
                showIcon="true"
                autoZIndex="true"
                [yearNavigator]="true"
                [yearRange]="yearRangeNavigator"
                appendTo="body"
                [disabledDates]="nonSchoolDates"
                #calendarMeetingDateTime
              ></p-datepicker>
            </div>
          </div>
          @if (
            (f.meetingDateTime.invalid && f.meetingDateTime.touched) ||
            f.meetingDateTime.dirty
          ) {
            <div>
              @if (f.meetingDateTime.errors?.required) {
                <small class="error-label"
                  >Valid date/time for 'Date of Meeting' is required and it
                  should be on or after Exclusion start date</small
                >
              }
            </div>
          }
          <div>
            @if (isInputDateInValid) {
              <small class="error-label"
                >Meeting time should be in 24 hours format</small
              >
            }
          </div>
          <div>
            @if (f.meetingDateTime.errors?.invalidDateFormat) {
              <small class="error-label">Invalid date format</small>
            }
          </div>
          <div>
            @if (f.meetingDateTime.errors?.dateBeforeExclStartDate) {
              <small class="error-label"
                >Meeting date time should not be before exclusion start
                date</small
              >
            }
          </div>
          <div>
            @if (f.meetingDateTime.errors?.dateAfterExclEndDate) {
              <small class="error-label"
                >Meeting date time should not be after exclusion end date</small
              >
            }
          </div>
          <div>
            @if (f.meetingDateTime.errors?.dateAfterAcademicYearEndDate) {
              <small class="error-label"
                >Meeting date time should not be after academic year end
                date</small
              >
            }
          </div>
          <div>
            @if (f.meetingDateTime.errors?.nonSchoolDateEntered) {
              <small class="error-label"
                >Meeting date time should be on a school day</small
              >
            }
          </div>
        </div>
      }
      @if (!isMeeting) {
        <div class="col-12 padding-zero">
          <div class="col-4 padding-top-a-rem">
            <label for="meetingDateTime"
              >Date meeting requested <span class="error-label">*</span></label
            >
            <div id="divRequestedMeetingDateTime" class="margin-top-half-rem">
              <p-datepicker
                formControlName="requestedDate"
                (onSelect)="setMinAppealDate($event)"
                (onInput)="onManualRequestedDateEntered($event)"
                [minDate]="minDateMeeting"
                [maxDate]="maxDateMeeting"
                dateFormat="dd/mm/yy"
                placeholder="DD/MM/YYYY"
                keepInvalid="false"
                [monthNavigator]="true"
                inputId="requestedDate"
                showIcon="true"
                autoZIndex="true"
                [yearNavigator]="true"
                [yearRange]="yearRangeNavigator"
                appendTo="body"
                [disabledDates]="nonSchoolDates"
                #calendarMeetingDateTime
              ></p-datepicker>
            </div>
          </div>
          @if (
            (f.requestedDate.invalid && f.requestedDate.touched) ||
            f.requestedDate.dirty
          ) {
            <div>
              @if (f.requestedDate.errors?.required) {
                <small class="error-label"
                  >Valid date for 'Date meeting requested' is required and it
                  should be on or after Exclusion start date</small
                >
              }
            </div>
          }
          <div>
            @if (f.requestedDate.errors?.dateBeforeExclStartDate) {
              <small class="error-label"
                >Date meeting requested should not be before exclusion start
                date</small
              >
            }
          </div>
          <div>
            @if (f.requestedDate.errors?.dateAfterExclEndDate) {
              <small class="error-label"
                >Date meeting requested should not be after exclusion end
                date</small
              >
            }
          </div>
          <div>
            @if (f.requestedDate.errors?.dateAfterAcademicYearEndDate) {
              <small class="error-label"
                >Date meeting requested should not be after academic year end
                date</small
              >
            }
          </div>
          <div>
            @if (f.requestedDate.errors?.nonSchoolDateEntered) {
              <small class="error-label"
                >Date meeting requested should be on a school day</small
              >
            }
          </div>
          <div>
            @if (f.requestedDate.errors?.invalidDateFormat) {
              <small class="error-label">Invalid date format</small>
            }
          </div>
        </div>
      }

      @if (!isMeeting) {
        <div class="col-12 padding-zero">
          <div class="col-4 padding-top-a-rem">
            <label for="appealMeetingDateTime">Meeting date and time </label>
            <div id="divAppealMeetingDateTime" class="margin-top-half-rem">
              <p-datepicker
                formControlName="appealMeetingDateTime"
                class="calendar-size"
                [minDate]="minDateAppealMeeting"
                [maxDate]="maxDateMeeting"
                (onSelect)="checkDateValidation($event)"
                (onInput)="onManualDateTimeEnter($event)"
                dateFormat="dd/mm/yy"
                placeholder="DD/MM/YYYY HH:MM"
                keepInvalid="false"
                [monthNavigator]="true"
                showTime="true"
                inputId="appealMeetingDateTime"
                showIcon="true"
                [yearNavigator]="true"
                [yearRange]="yearRangeNavigator"
                appendTo="body"
                [disabledDates]="nonSchoolDates"
              ></p-datepicker>
            </div>
          </div>
          <div>
            @if (isInvalidDate) {
              <small class="error-label"
                >Meeting date/time should be valid and it should be on or after
                meeting requested date</small
              >
            }
          </div>
          <div>
            @if (isInputDateInValid) {
              <small class="error-label"
                >Meeting time should be in 24 hours format</small
              >
            }
          </div>
          <div>
            @if (
              f.appealMeetingDateTime.errors?.dateBeforeMeetingRequestedDate
            ) {
              <small class="error-label"
                >Meeting date time should not be before meeting requested
                date</small
              >
            }
          </div>
          <div>
            @if (f.appealMeetingDateTime.errors?.invalidDateFormat) {
              <small class="error-label">Invalid date format</small>
            }
          </div>
          <div>
            @if (f.appealMeetingDateTime.errors?.dateBeforeExclStartDate) {
              <small class="error-label"
                >Meeting date time should not be before exclusion start
                date</small
              >
            }
          </div>
          <div>
            @if (f.appealMeetingDateTime.errors?.dateAfterExclEndDate) {
              <small class="error-label"
                >Meeting date time should not be after exclusion end date</small
              >
            }
          </div>
          <div>
            @if (f.appealMeetingDateTime.errors?.dateAfterAcademicYearEndDate) {
              <small class="error-label"
                >Meeting date time should not be after academic year end
                date</small
              >
            }
          </div>
          <div>
            @if (f.appealMeetingDateTime.errors?.nonSchoolDateEntered) {
              <small class="error-label"
                >Meeting date time should be on a school day</small
              >
            }
          </div>
        </div>
      }
      <div class="col-12 padding-zero">
        <div class="col-6 padding-top-a-rem">
          <label for="meetingStatus">Meeting status</label>
          <div class="margin-top-half-rem">
            <p-select
              formControlName="meetingStatus"
              [options]="meetingStatusOptions"
              optionLabel="description"
              optionValue="description"
              id="meetingStatus"
              scrollHeight="85px"
              placeholder="Please select"
              #meetingStatusDropdown
            ></p-select>
          </div>
        </div>
      </div>
      @if (isEdit) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-top-a-rem">
            <label for="meetingOutcome">Meeting outcome</label>
            <div class="margin-top-half-rem">
              <p-select
                formControlName="decisionResult"
                [options]="meetingOutcomeOptions"
                optionLabel="description"
                optionValue="description"
                id="meetingOutcome"
                placeholder="Please select"
                (onChange)="onOutcomeChange($event.value)"
                #meetingOutcomeDropdown
              ></p-select>
            </div>
          </div>
        </div>
      }
      @if (isReinstateFieldsVisible) {
        <div class="col-6 padding-zero">
          <div class="padding-top-a-rem">
            <div class="col-8 padding-zero">
              <label for="reinstatementDate"
                >Reinstate date <span class="error-label">*</span></label
              >
              <div id="divReinstatementDate" class="margin-top-half-rem">
                <p-datepicker
                  class="calendar-size"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  [minDate]="minDateMeeting"
                  [maxDate]="maxReinstateDate"
                  inputId="reinstatementDate"
                  showIcon="true"
                  formControlName="reinstatementDate"
                  autoZIndex="true"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRangeNavigator"
                  appendTo="body"
                  [disabledDates]="nonSchoolDates"
                  (onInput)="onManualReinstatementDateEntered($event)"
                ></p-datepicker>
              </div>
            </div>
            @if (
              (f.reinstatementDate.invalid && f.reinstatementDate.touched) ||
              f.reinstatementDate.dirty
            ) {
              <div class="col-8 padding-zero">
                <div>
                  @if (f.reinstatementDate.errors?.required) {
                    <small class="error-label"
                      >Reinstate date is required and it should be within the
                      exclusion period</small
                    >
                  }
                </div>
                <div>
                  @if (f.reinstatementDate.errors?.invalidDateFormat) {
                    <small class="error-label">Invalid date format</small>
                  }
                </div>
                <div>
                  @if (f.reinstatementDate.errors?.dateBeforeExclStartDate) {
                    <small class="error-label"
                      >Reinstate date should not be before exclusion start
                      date</small
                    >
                  }
                </div>
                <div>
                  @if (f.reinstatementDate.errors?.dateAfterExclEndDate) {
                    <small class="error-label"
                      >Reinstate date should not be after exclusion end
                      date</small
                    >
                  }
                </div>
                <div>
                  @if (
                    f.reinstatementDate.errors?.dateAfterAcademicYearEndDate
                  ) {
                    <small class="error-label"
                      >Reinstate date should not be after academic year end
                      date</small
                    >
                  }
                </div>
                <div>
                  @if (f.reinstatementDate.errors?.nonSchoolDateEntered) {
                    <small class="error-label"
                      >Reinstate date should be on a school day</small
                    >
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (isReinstateFieldsVisible) {
        <div class="col-6 padding-zero">
          <div class="padding-top-a-rem">
            <div>
              <label for="reinstatementReason"
                >Reinstate reason <span class="error-label">*</span></label
              >
              <div class="margin-top-half-rem">
                <p-select
                  formControlName="reinstatementReason"
                  [options]="reinstateReasonList"
                  optionLabel="description"
                  optionValue="description"
                  placeholder="Please select"
                  id="reinstatementReason"
                  #reinstateReasonDropdown
                ></p-select>
              </div>
            </div>
            @if (
              (f.reinstatementReason.invalid &&
                f.reinstatementReason.touched) ||
              f.reinstatementReason.dirty
            ) {
              <div>
                @if (f.reinstatementReason.errors?.required) {
                  <small class="error-label"
                    >Reinstate reason is required</small
                  >
                }
              </div>
            }
          </div>
        </div>
      }
      @if (isEdit) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-top-a-rem">
            <p-checkbox
              formControlName="carersAttended"
              binary="true"
              inputId="attended"
            ></p-checkbox>
            <label for="attended" class="ml-2"> Parent/Carer attended </label>
          </div>
        </div>
      }
      @if (!isMeeting) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-top-a-rem">
            <p-checkbox
              formControlName="pupilAppellant"
              binary="true"
              inputId="appealant"
            ></p-checkbox>
            <label for="appealant" class="ml-2"> Pupil is the appellant </label>
          </div>
        </div>
      }
      @if (!isMeeting && isEdit) {
        <div class="col-12 padding-zero">
          <div class="col-6 padding-top-a-rem">
            <p-checkbox
              formControlName="senExpertAttended"
              binary="true"
              inputId="expertAttended"
              (ngModelChange)="senExpertAttendedChange($event)"
            ></p-checkbox>
            <label for="expertAttended" class="ml-2">
              SEN expert attended
            </label>
          </div>
        </div>
      }
      @if (isSenExpertAttendedChecked && !isMeeting && isEdit) {
        <div class="col-8 padding-zero margin-left-3REM">
          <div class="col-8">
            <div>
              <label
                class="margin-bottom-half-rem"
                for="senExpertAttendedDetails"
                >SEN expert name <span class="error-label">*</span></label
              >
            </div>
            <div>
              <input
                [class.is-invalid]="
                  f.senExpertAttendedDetails.invalid &&
                  f.senExpertAttendedDetails.touched
                "
                type="text"
                formControlName="senExpertAttendedDetails"
                pInputText
              />
            </div>
            @if (
              (f.senExpertAttendedDetails.invalid &&
                f.senExpertAttendedDetails.touched) ||
              f.senExpertAttendedDetails.dirty
            ) {
              <div class="float-left">
                @if (f.senExpertAttendedDetails.errors?.required) {
                  <small class="error-label">SEN expert name is required</small>
                }
              </div>
            }
          </div>
        </div>
      }
      <div class="col-12 padding-zero button-style margin-top-buttons">
        <button
          pButton
          type="button"
          class="margin-right float-right"
          label="Save meeting"
          (click)="saveMeeting()"
          [disabled]="isSaveClicked"
        ></button>
        <button
          pButton
          type="button"
          class="margin-right float-right"
          (click)="closePopup()"
          label="Cancel"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
